import { createRouter as createVueRouter, createWebHistory } from 'vue-router'
import { fetchMenus } from '@/api/menu'

// 提前创建 router 实例（基础路由）
const baseRoutes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  },
  {
    path: '/article/:id',
    name: 'PostSearchDetail',
    component: () => import('@/views/search/PostSearchDetail.vue')
  },
  {
    path: '/company-introduce',
    name: 'CompanyIntroduce',
    component: () => import('@/components/singlePage/CompanyIntroduce.vue')
  },
    {
    path: '/recruitment',
    name: 'Recruitment',
    component: () => import('@/views/RecruitmentView.vue')
  },
    {
    path: '/contactUs',
    name: 'ContactUs',
    component: () => import('@/views/contactUs.vue')
  },
]

export const router = createVueRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: baseRoutes
})

// 供 main.js 调用
export async function setupRouter() {
  try {
    const menuData = await fetchMenus()
    const dynamicRoutes = generateRoutesFromMenu(menuData.menuItems)

    dynamicRoutes.forEach(route => {
      router.addRoute(route)
    })

    console.log('🚀 当前动态路由结构树：')
    printRoutesTree(dynamicRoutes)
  } catch (error) {
    console.error('❌ 路由初始化失败:', error)
  }
}

// 外部可以调用的工具函数
function generateRoutesFromMenu(menuItems, parentPath = '', parentItem = null) {
  return menuItems.map(item => {
    const rawPath = item.status?.href || ''
    const fullPath = normalizePath(rawPath)
    item.parent = parentItem

    const route = {
      path: normalizePath(fullPath.replace(parentPath, '')),
      name: item.metadata?.name || rawPath,
      component: () => import('@/components/common/DynamicContent.vue'),
      meta: {
        title: item.displayName,
        menuItem: item
      },
      children: item.children ? generateRoutesFromMenu(item.children, fullPath, item) : []
    }

    return route
  })
}

function normalizePath(path) {
  if (!path) return ''
  return path.startsWith('/') ? path : '/' + path.replace(/^\/+/, '')
}

function printRoutesTree(routes, indent = 0) {
  const prefix = '  '.repeat(indent)
  routes.forEach(route => {
    console.log(`${prefix}📌 name: ${route.name}, path: ${route.path}`)
    if (route.children && route.children.length > 0) {
      printRoutesTree(route.children, indent + 1)
    }
  })
}
